import { View } from "react-native";
import moment from "moment";
import { readableDate } from "../utils/dateUtils";
import PopOver from "./PopOver";
import { Text } from "react-native-paper";
import Button from "./Button";

export const getFutureDate = (dateString: string) => {
  const today = moment().startOf("day");
  const date = moment(dateString);
  const endDate = date.isAfter(today) ? date.format("YYYY-MM-DD") : null;
  return endDate;
};

export default function FutureDateEmploymentPopOver({
  futureDateValue,
  setFutureDateValue,
}: {
  futureDateValue: string | null;
  setFutureDateValue: (value: string | null) => void;
}) {
  const onDismissFutureDate = () => setFutureDateValue(null);

  return (
    <PopOver onDismiss={onDismissFutureDate} visible={!!futureDateValue} testID="future-date-employment-pop-over">
      <Text className="text-title-5 font-700 text-center">Future date selected</Text>

      <View className="my-4">
        <Text className="text-link-normal font-400 text-center">
          You've selected {futureDateValue && readableDate(futureDateValue)} as the future effective date for this employment.
          Until this date, your employment status or classification will remain unchanged.
        </Text>
      </View>

      <Button mode="secondary" onPress={onDismissFutureDate}>
        Okay
      </Button>
    </PopOver>
  );
}
